import React from 'react';
import { useTranslation } from 'react-i18next';
import { Placeholder } from '../Placeholder';
import { useFromToContext } from '../../../shared';
import { DateFromTo, TopCategoriesComponent } from '../../../../generated/graphql';
import { routePaths } from '../../../../routePaths';
import CategoriesView from './CategoriesView';

const TopCategoriesList = () => {
    const { t } = useTranslation();
    const { dateFromTo } = useFromToContext();

    const linkUrl = routePaths.reportsCategories;
    return (
        <TopCategoriesComponent
            variables={{ dateFromTo: dateFromTo as DateFromTo }}
            fetchPolicy='network-only'
            Loader={() => <Placeholder minHeight={294} />}
        >
            {({ data: { topCategories } }) => (
                <CategoriesView
                    title={t('Top 5 category sales')}
                    categories={topCategories}
                    itemsPerRow={5}
                    linkUrl={linkUrl}
                />
            )}
        </TopCategoriesComponent>
    );
};
export default TopCategoriesList;